<template>
  <Modal
    :open="props.open"
    @close-modal="$emit('close-modal')"
    customHeight="h-112"
    customWidth="lg:w-120"
  >
    <template #modal-header>
      <div class="">
        <div class="flex items-center">
          <Icon name="Check" class="w-4 h-4 mr-1 stroke-info" />
          <div class="text-sm font-inter font-semibold text-info">Confirm</div>
        </div>
        <div class="font-league tracking-[-.56px] font-semibold text-[1.75rem] text-strongest">
          Delete Beneficial Owner
        </div>
      </div>
    </template>

    <template #modal-body>
      <div class="p-6 text-error text-lg" v-if="props.modal_config.action == 'permanently_delete'">
        You are choosing to permanently delete this beneficial owner. This action cannot be undone.
        Are you sure you want to proceed?
      </div>
      <div class="p-6 text-error text-lg" v-if="props.modal_config.action == 'remove_from_entity'">
        You are choosing to remove this beneficial owner from the entity. Are you sure you want to
        proceed?
      </div>
    </template>
    <template #modal-footer>
      <div class="flex justify-end gap-2">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="sm" class="">
          <template #label>Cancel</template>
        </Button>
        <Button @click="handleConfirm()" variant="primary-grey" size="sm" class="">
          <template #label>Confirm</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
// IMPORTS
import { Modal, Icon, Button } from "@/components";
import { useCrudStore, useUIStore, useSchemaStore } from "@/stores";

//STORES
const crudStore = useCrudStore();
const UIStore = useUIStore();
const schemaStore = useSchemaStore();

//EMITS AND PROPS
const emit = defineEmits(["close-modal", "confirm"]);
const props = defineProps({
  open: { type: Boolean, required: true },
  modal_config: { type: Object, required: true },
});

// COMPONENT LOGIC AND FUNCTIONS
async function handleConfirm() {
  try {
    if (props.modal_config.action === "permanently_delete") {
      let delete_res = await crudStore.delete("contacts", [
        {
          field_name: "record_id",
          operator: "eq",
          value: props.modal_config.record_id,
        },
      ]);
    }

    if (props.modal_config.action === "remove_from_entity") {
      let current_entity_ids = props.modal_config.entity_ids;
      let entity_id_to_remove = props.modal_config.entity_id_to_remove;

      let updated_entity_ids = current_entity_ids.filter((id) => id !== entity_id_to_remove);

      let update = {
        entity_ids: updated_entity_ids,
      };

      update = schemaStore.addCreatedUpdatedFields(update, false, true);

      let update_response = await crudStore.update(
        "contacts",
        [
          {
            field_name: "record_id",
            operator: "eq",
            value: props.modal_config.record_id,
          },
        ],
        update
      );

      if (update_response.status !== 200) {
        throw new Error("Failed to remove beneficial owner from entity");
      }
    }

    emit("confirm", {
      type: "beneficial_owner",
      record_id: props.modal_config.record_id,
    });

    emit("close-modal");
  } catch (error) {
    let action_word = props.modal_config.action === "permanently_delete" ? "delete" : "remove";

    var alert = {
      type: "error",
      message: `Failed to ${action_word} beneficial owner.`,
    };
    UIStore.animateNotificationAlert(alert);
    emit("close-modal");
  }
}
</script>
